<template lang="html">
<div class="map-save">

    <div
        class="mapboxgl-ctrl mapboxgl-ctrl-group map-save-control"
        id="map-save-button"
        @click="show(!value)">
        <v-tooltip right>
            <button type="button" slot="activator">
                <v-icon class="mbgl-color">save</v-icon>
            </button>
            <span>Save...</span>
        </v-tooltip>
    </div>

    <v-dialog persistent :value="value" max-width="450">
        <v-card>
            <v-card-title class="headline primary white--text">
                Save
                <v-spacer></v-spacer>
                <v-btn @click="show(false)" flat icon class="white--text close-button ma-0 pa-0">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <h3 class="subheadline">
                    Save map view
                </h3>

                <p>Use this URL to save or share your current view and filters</p>

                <v-text-field
                    id="short-url-input"
                    label="Map view URL"
                    prepend-icon="mdi-clipboard-text"
                    :prepend-icon-cb="copyShortUrl"
                    @click="selectShortUrlInput"
                    color="accent"
                    hide-details
                    full-width
                    readonly
                    :value="mapViewShortUrl"
                ></v-text-field>

                <template v-if="featuresUrl">
                    <h3 class="subheadline">
                        <slot name="features-headline">Download map features</slot>
                    </h3>

                    <p>Download map data as a CSV file</p>

                    <v-btn color="primary" @click="downloadCsv" block large>
                        <v-progress-circular
                        v-if="loadingCsv"
                        :width="3"
                        class="mr-2"
                        indeterminate color="white" />
                        Download map data
                    </v-btn>
                </template>

            </v-card-text>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import axios from 'axios';
import fileDownload from 'js-file-download';
import gql from 'graphql-tag';
import ShortUniqueId from 'short-unique-id';

import { apolloClient } from '@/apollo/apollo';
import mapPromiseMixin from '@/mixins/map';
import * as actions from '@/constants/actions';

export default {
    mixins: [
        mapPromiseMixin,
    ],
    props: {
        value: Boolean,
        featuresUrl: String,
    },
    data() {
        return {
            loadingCsv: false,
            mapViewShortUrl: '...',
        };
    },
    mounted() {
        this.mapViewShortUrl = window.location.href;
    },
    methods: {
        /**
         * change visible state of the dialog
         * hides by default
         * @param  {Boolean} [on=false] true for visible
         */
        show(on = false) {
            this.$emit('input', on);
        },
        /**
         * fetch CSV file and trigger download
         */
        async downloadCsv() {
            this.loadingCsv = true;

            const { data } = await axios.get(`${this.featuresUrl}/all.csv`);
            fileDownload(data, 'map-data.csv');

            this.loadingCsv = false;
        },
        /**
         * refresh short URL from the current map state
         */
        async createShortUrl() {
            // create short url string
            const uid = new ShortUniqueId();
            const random = uid.randomUUID(6);
            const pageRoute = this.$route.path;
            const routePart = pageRoute.replace('/', '');
            const shortUrlPrefix = 'saved/';
            const key = `${shortUrlPrefix}${routePart}-${random}`;
            const domainPart = window.location.origin;
            const fullShortUrl = `${domainPart}/${key}`;
            this.mapViewShortUrl = fullShortUrl;

            // create JSON object of map and filter settings
            const filterSettings = this.$store.state.filterSettings;
            const map = await this.mapPromise;
            const mapZoom = map.getZoom();
            const mapCenter = map.getCenter();

            const values = {
                mapZoom,
                mapCenter,
                filterSettings,
                pageRoute,
            };
            const result = await apolloClient.mutate({
                mutation: gql`mutation createShortUrl($key: String!, $values: JSON!) {
                    setUrlShortener(key: $key, values: $values)
                }`,
                variables: { key, values },
            });
            // @TODO: catch errors if the key is already used
            return result;
        },
        copyShortUrl() {
            this.selectShortUrlInput();
            document.execCommand('Copy');
            this.$store.dispatch(actions.TRIGGER_TOAST, 'Copied URL to the clipboard');
        },
        selectShortUrlInput() {
            const input = document.getElementById('short-url-input');
            input.select();
        },
    },
    watch: {
        value(val) {
            if (val) {
                this.createShortUrl();
            }
        },
    },
};
</script>

<style lang="scss">
.map-save {

    .mbgl-color {
        color: #333;
    }

    .mapboxgl-ctrl {
        position: absolute;
        top: 80px;
        left: 10px;
        button {
            height: 30px;
            width: 30px;
        }
    }

    .close-button {
        right: 0;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/MapSaveButton.vue